export default function hasOwnProp(a, b) {
    return Object.prototype.hasOwnProperty.call(a, b);
}



//////////////////
// WEBPACK FOOTER
// ./~/moment/src/lib/utils/has-own-prop.js
// module id = 81
// module chunks = 3